module.exports = __webpack_public_path__ + "img/img28.542f6efa.png";